import {
  Box,
  Button,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  Radio,
  RadioGroup,
  TextField,
} from '@mui/material';
import ShareIcon from '@mui/icons-material/Share';
import { Autocomplete } from '@mui/material';
import React, { useState } from 'react';
import { toast } from 'react-toastify';
import api from '../../services/api';

export function RegisteredParnerInvites({ formData, partners }) {
  const [partner, setPartner] = useState(null);

  const [experimentName, setExperimentName] = useState(null);

  const [areInvitesInfinite, setAreInvitesInfinite] = useState('yes');
  const [inviteCodeType, setInviteCodeType] = useState('random');
  const [inviteCode, setInviteCode] = useState('');

  const [duration, setDuration] = useState(null);
  const [budget, setBudget] = useState(null);
  const [limit, setLimit] = useState(null);
  const [generatingInvite, setGeneratingInvite] = useState(false);
  const [inviteUrl, setInviteUrl] = useState(false);

  const handleGeneratePartnerInvite = async () => {
    setInviteUrl(null);

    const body = {
      partner_id: partner?.id,
      duration: Number(duration),
      experiment_name: experimentName,
      country_id: formData.selectedCountry,
      budget: Number(budget),
      limit: areInvitesInfinite === 'yes' ? 999999 : Number(limit),
      channel: formData.channel,
    };

    if (inviteCode && inviteCodeType === 'custom') {
      if (inviteCode.match(/^[A-Za-z\d]{3,40}$/)) {
        body.token = inviteCode;
      } else {
        toast('O código de convite deve somente contar letras e números entre 3 e 40 caracteres.', { type: 'error' });

        return;
      }
    }

    setGeneratingInvite(true);
    try {
      const response = await api.post('/invite/create', body);

      setInviteUrl(response.data.url);
      setGeneratingInvite(false);
    } catch (error) {
      setGeneratingInvite(false);

      if (error.response?.data?.error) {
        toast(error.response.data.error.message, { type: 'error' });
      } else {
        toast('Ocorreu um erro ao gerar o convite. Tente novamente.', { type: 'error' });
      }
    }
  };

  return (
    <>
      <Grid xs={12} md={12} item>
        <Autocomplete
          options={partners}
          getOptionLabel={option => option.name}
          getOptionKey={option => option.id}
          onChange={(_e, value) => {
            if (value && value.name) {
              setPartner(value);
            } else {
              setPartner(null);
            }
          }}
          renderInput={params => (
            <TextField style={{ width: '100%' }} {...params} label='Parceiro' variant='outlined' />
          )}
        />
      </Grid>

      <Grid xs={12} md={12} item>
        <TextField
          style={{ width: '100%' }}
          label='Orçamento'
          variant='outlined'
          type='number'
          onChange={e => {
            setBudget(e.target.value);
          }}
        />
      </Grid>

      <Grid xs={12} md={12} item>
        <TextField
          style={{ width: '100%' }}
          label='Nome do experimento'
          variant='outlined'
          onChange={e => {
            setExperimentName(e.target.value);
          }}
        />
      </Grid>

      <Grid xs={12} md={12} item>
        <TextField
          style={{ width: '100%' }}
          label='Duração (dias)'
          variant='outlined'
          type='number'
          onChange={e => {
            setDuration(e.target.value);
          }}
        />
      </Grid>

      <Grid xs={12} md={12} item justifyContent='space-between'>
        <FormControl fullWidth component='fieldset'>
          <FormLabel style={{ textAlign: 'left' }} component='legend'>
            Convites infinitos?
          </FormLabel>
          <RadioGroup
            row
            aria-label='infiniteinvites'
            name='infiniteinvites'
            value={areInvitesInfinite}
            onChange={e => setAreInvitesInfinite(e.target.value)}
          >
            <FormControlLabel value='yes' control={<Radio color='primary' />} label='Sim' />
            <FormControlLabel value='no' control={<Radio color='primary' />} label='Não' />
          </RadioGroup>
        </FormControl>
      </Grid>

      {areInvitesInfinite === 'no' && (
        <Grid xs={12} md={12} item>
          <TextField
            style={{ width: '100%' }}
            onChange={e => {
              setLimit(e.target.value);
            }}
            label='Quantidade'
            variant='outlined'
            type='number'
          />
        </Grid>
      )}

      <Grid xs={12} md={12} item>
        <FormControl fullWidth component='fieldset'>
          <FormLabel style={{ textAlign: 'left' }} component='legend'>
            Código de convite
          </FormLabel>
          <RadioGroup
            row
            aria-label='inviteCodeType'
            name='inviteCodeType'
            value={inviteCodeType}
            onChange={e => setInviteCodeType(e.target.value)}
          >
            <FormControlLabel value='random' control={<Radio color='primary' />} label='Aleatório' />
            <FormControlLabel value='custom' control={<Radio color='primary' />} label='Customizado' />
          </RadioGroup>
        </FormControl>
      </Grid>

      {inviteCodeType === 'custom' && (
        <Grid xs={12} md={12} item>
          <TextField
            style={{ width: '100%' }}
            onChange={e => {
              setInviteCode(e.target.value);
            }}
            label='Código de convite'
            variant='outlined'
          />
        </Grid>
      )}

      <Box m='auto' mt={3} width='100%' display='flex' justifyContent='center'>
        <Button disabled={generatingInvite} onClick={handleGeneratePartnerInvite} variant='contained' color='primary'>
          {generatingInvite ? 'Gerando...' : 'Gerar'}
        </Button>
      </Box>

      {inviteUrl && (
        <Box m='auto' mt={3}>
          <Button
            onClick={() => {
              navigator.clipboard.writeText(inviteUrl);
            }}
            disabled={generatingInvite}
          >
            <ShareIcon style={{ color: 'blue', fontSize: '36px', cursor: 'pointer' }} />
          </Button>
        </Box>
      )}
    </>
  );
}
